//* REACTIVITY UTILITIES (these are available in Vue 3) *//
import { unref, Ref } from 'vue';

export type MaybeRef<T> = T | Ref<T>;
export type MaybeRefOrGetter<T> = MaybeRef<T> | (() => T);

export const toValue = <T>(arg: MaybeRefOrGetter<T>): T =>
	typeof arg === 'function' ? (arg as () => T)() : unref(arg);
